import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["name"],
  _excluded2 = ["name"];
import { BlankIcon } from './components/BlankIcon';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
let getIconComponent;

// Jest does not support require.context() so we feature-detect and fall back to require()
if (typeof __webpack_require__ === 'function') {
  const iconsContext = require.context('./components', false, /\.tsx$/);
  getIconComponent = name => {
    try {
      const iconModule = iconsContext(`./${name}Icon.tsx`);
      return iconModule[`${name}Icon`];
    } catch (error) {
      if (module.hot) {
        // Avoid an HMR error while the name prop is being edited
        return BlankIcon;
      } else {
        return undefined;
      }
    }
  };
} else {
  const allComponents =
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  require('./components');
  getIconComponent = name => {
    return allComponents[`${name}Icon`];
  };
}

/**
 * Renders any icon by name from the icon set.
 *
 * WARNING: Avoid using DynamicIcon in production code when possible.
 * This component imports all icons, significantly increasing bundle size.
 * For better performance, import and use specific icons directly:
 * import { AnchorIcon } from 'foundations-assets';
 */
export const DynamicIcon = _ref => {
  let {
      name
    } = _ref,
    iconProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const IconComponent = useMemo(() => getIconComponent(name), [name]);
  if (!IconComponent) {
    throw new Error(`Icon "${name}" not found`);
  }
  return /*#__PURE__*/_jsx(IconComponent, Object.assign({}, iconProps));
};

// Apparently this is a thing the old UIIcon supported
// See https://git.hubteam.com/HubSpot/UIComponents/blob/master/icons/bin/constants/aliases.js
const aliases = {
  chain: 'Link',
  'comment-o': 'Comments',
  'comments-o': 'Comments',
  contact: 'Contacts',
  copy: 'Duplicate',
  'external-link': 'ExternalLink',
  eye: 'View',
  pencil: 'Edit',
  photo: 'InsertImage',
  'upload-light': 'Upload',
  'warning-triangle': 'Warning'
};

/**
 * Shim for the UIComponents-style icon component that converts lowercase names to the newer format.
 *
 * @deprecated Prefer direct trellis icon usage. This shim exists only for compatibility with areas that can't
 * constrain their icon usage.
 */
export const TransitionalIcon = _ref2 => {
  let {
      name
    } = _ref2,
    iconProps = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  const capitalizedName = aliases[name] || name.charAt(0).toUpperCase() + name.slice(1);
  return /*#__PURE__*/_jsx(DynamicIcon, Object.assign({
    name: capitalizedName
  }, iconProps));
};